const loadingInformation = [
    {
        "text": "We are just getting your environment ready to go",
        "colour": "#232C3D"
    },
    {
        "text": "Preparation of your instance may take up to 5 minutes",
        "colour": "#232C3D"
    }
]
const duplicatingInformation = [
    {
        "text": "We are just getting your environment ready to go",
        "colour": "#232C3D"
    },
    {
        "text": "Duplication can take up to 20 minutes",
        "colour": "#232C3D"
    },
]



export {loadingInformation, duplicatingInformation}